import { defaultCurrency } from "@zapier/currency/esm/hooks/useCurrencies";
import { formatPrice } from "./formatPrice";
import { formatPriceWithCurrencySymbol } from "./formatPriceWithCurrencySymbol";
/**
 * Applies currency multiplier and formats price.
 */
export const formatPriceToBeInCurrency = (price, currency = defaultCurrency, includeSymbol = true, formattingOptions = {}) => {
  const adjusted = price * currency.multiplier;
  return includeSymbol ? formatPriceWithCurrencySymbol(adjusted, formattingOptions, currency.symbol) : formatPrice(adjusted, formattingOptions);
};
//# sourceMappingURL=formatPriceToBeInCurrency.js.map